import './tabs.css';

const tabs = document.querySelectorAll('.tabs')

class Tab {
    constructor(tab, i) {
        this.tab = tab
        this.index = i
        this._open = false
        this.name = tab.dataset.tab
        this.enable = true
    }

    set open(open) {
        if (!this.enable) {
            return;
        }

        this._open = open
        if(open) {
            this.tab.dataset.active = true
        }
        else {
            delete this.tab.dataset.active
        }
    }
    get open() {
        return this._open
    }

    updateState(i) {
        this.open = i == this.index
    }
    disable() {
        this.enable = false
    }
}

class Tabs {
    constructor(container) {
        this.container = container
        this.buttons = container.querySelector('.tabs-buttons')
        this.tabs = [ ...container.querySelectorAll('.tab-content') ].map(( tab, i ) => {
            const t = new Tab(tab, i)
            
            this.createButton(t)

            return t
        })

        if(this.tabs.length > 0) {
            window.setTimeout(() => this.selectTab(0), 200)
        }

        container.classList.add('active')
    }

    createButton(tab) {
        const button = document.createElement('button')
        button.setAttribute('type', 'button')
        button.dataset.tab = tab.index
        button.textContent = tab.name
        button.classList.add('tab-button')

        button.addEventListener('click', () => this.selectTab(tab.index))

        if (tab.tab.textContent.trim() == '') {
            tab.disable()
            button.setAttribute('disabled', '')
        }

        this.buttons.append(button)
    }

    selectTab(i) {
        this.tabs.forEach(tab => {
            tab.updateState(i)
            this.buttons.querySelectorAll(`.tab-button:not([data-tab="${i}"])`).forEach(b => delete b.dataset.active)
            this.buttons.querySelector(`.tab-button[data-tab="${i}"]`).dataset.active = ''
        }) 
    }
}

document.querySelectorAll('.tabs').forEach(tabs => {
    new Tabs(tabs) 
})
